<style scoped>
    @font-face {
            font-family: SourceSansPro-Regular;
            src: url(../assets/fonts/SourceSansPro-Regular.ttf);
        }

        .clearfix:after {
          content: "";
          display: table;
          clear: both;
        }

        a {
          color: #0087C3;
          text-decoration: none;
        }

        body {
          position: relative;
          width: 21cm;
          height: 29.7cm;
          margin: 0 auto;
          color: #000;
          background: #FFFFFF;
          font-family: SourceSansPro-Regular.ttf;
          font-size: 14px;
          font-family: SourceSansPro-Regular.ttf;
        }

        header {
          padding: 2px 0;
          margin-bottom: 2px;
          border-bottom: 1px solid #AAAAAA;
        }

        #logo {
          float: left;
          margin-top: 8px;
        }

        #logo img {
            height: 70px;
        }

        #company {
          float: center;
          text-align: center;
        }

        #passdetails {
          padding-right: 6px;
          float: right;
          text-align: left;
        }

        #taxinvoice {
          float: center;
          text-align: center;
          width: 100%;
          font-size: 1.4em;
          font-weight: bold;
          text-transform: uppercase;
        }


        #details {
          margin-bottom: 10px;
        }

        #client {
          padding-left: 2px;
          border-left: 6px solid #0087C3;
          float: left;
        }

        #client .to {
          color: #000;
        }

        h2.name {
          font-size: 1.0em;
          font-weight: normal;
          margin: 0;
        }

        #invoice {
          float: right;
          text-align: right;
        }

        #invoice h1 {
          color: #000;
          font-size: 1.2em;
          line-height: 0.2em;
          font-weight: normal;
          margin: 0  0 1px 0;
        }

        #invoice .date {
          font-size: 1.0em;
          color: #000;
        }

        #invoice .line {
          font-size: 1.2em;
          color: #000;
          font-weight: bold;
        }

        table {
          width: 100%;
          font-size: 1.0em;
          border-collapse: collapse;
          border-spacing: 0;
          margin-bottom: 2px;
          background: #fff;
        }


        table td {
          padding: 2px;
          background: #fff;
          text-align: center;
        }

        table th {
          padding: 4px;
          white-space: nowrap;
          font-size: 1.0em;
          font-color: #fff;
          font-weight: bold;
          background-color: #EEEEEE;
          text-align: center;
        }

        table td {
          text-align: center;
        }

        table td h3{
          color: #000;
          font-size: 1.0em;
          font-weight: normal;
          margin: 0 0 0.2em 0;
        }

        table .history {
          padding: 3px;
          font-size: 1.0em;
          background: #fff;
          text-align: left;
          border-top: 1px solid #AAAAAA;
        }
        table .no {
          color: #000;
          background: #fff;
        }

        table .desc {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .shipper {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .gst {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .sheaderl {
          text-align: right;
          font-size: 1.0em;
          background: #fff;
        }

        table .sheaderr {
          text-align: left;
          font-size: 1.0em;
          background: #fff;
        }

        table .sign {
          text-align: right;
          font-size: 1.0em;
          background: #fff;
        }

        table .words {
          text-align: left;
          font-size: 1.0em;
          background: #EEEEEE;
        }

        table .unit {
          text-align: center;
          background: #fff;
        }

        table .qty {
          text-align: center;
          background: #fff;
        }

        table .total {
          text-align: center;
          background: #fff;
        }
        table td.desc,
        table td.unit,
        table td.qty,
        table td.total {
          font-size: 1.0em;
        }

        table tbody tr:last-child td {
          border: none;
        }

        table tfoot td {
          padding: 2px;
          background: #FFFFFF;
          border-bottom: none;
          font-size: 1.2em;
          white-space: nowrap;
          border-top: 1px solid #AAAAAA;
        }

        table tfoot tr:first-child td {
          border-top: none;
        }

        table tfoot tr:last-child td {
          color: #000;
          padding-top: 20px;
          font-size: 1.0em;
          border-top: 1px solid #57B223;

        }

        table tfoot tr td:first-child {
          border: none;
        }

        #taxable {
          text-align: center;
        }

        #id {
            text-align: left;
            font-size: 1.0em;
            background: #fff;
        }

        #thanks{
          font-size: 1em;
          margin-bottom: 50px;
        }

        #notices{
          padding-left: 6px;
          border-left: 6px solid #0087C3;
        }

        #notices .notice {
          font-size: 1.2em;
        }

        footer {
          color: #000;
          width: 100%;
          height: 25px;
          position: absolute;
          padding: 8px 0;
          text-align: center;
        }


</style>

<template>
    <v-layout>
        <body>
          <div>
        <header class="clearfix">
            <div id="logo">
                <img src="../assets/logo.png" class="d-inline-block align-top" alt="">
            </div>
            <div id="company">
                <h2 class="name" style="font-weight: bold;">VILSONS CONTAINER FREIGHT STATION</h2>
                <div>(A Unit of Vilsons Shipping Private Limited)</div>
                <div style="font-weight: bold;">33AAACV6328H1ZF</div>
                <div>3/2B, Harbour Express Road, Near Camp I, Tuticorin - 628 006</div>
                <div>Ph.No.: 0461-2352955,2352055,7373012055 | vilsons.cfs@gmail.com | www.cfs.vilsonsshipping.com</div>
            </div>
            <div style="text-align: center; font-size: 16px; font-weight: bold;">IMPORT GATE IN PASS
            </div>
            <div id="details" class="clearfix">
                <div id="client">
                  <h2 class="name">IGM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.igm_no }} &amp; {{ gin_pass_details.igm_date }}</h2>
                  <h2 class="name">BL No.&nbsp;:&nbsp;{{ gin_pass_details.bl_no }} &amp; {{ gin_pass_details.bl_date }}</h2>
                  <h2 class="name">Line&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.line }}</h2>
                  <h2 class="name" style="font-weight:bold;">Cargo&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.cargo }}</h2>
                </div>
                <div id="invoice" class="clearfix">
                  <div id="passdetails">
                    <h2 class="name" style="font-weight:bold;">Pass No.:&nbsp;{{ gin_pass_details.pass_no }}</h2>
                    <h2 class="name" style="font-weight:bold;">In Date&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.in_date }}</h2>
                    <h2 class="name">Port Out Time:&nbsp;{{ gin_pass_details.port_out_time }}</h2>
                    <h2 class="name">Work Order No.&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.job_order_no }}</h2>
                  </div>
                </div>
            </div>
        </header>
        <main>
            <table border="1" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Container</th>
                    <th>Size/type</th>
                    <th>Seal No.</th>
                    <th>Truck No</th>
                    <th>Vessel/voyage</th>
                    <th>EIR No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="no">01</td>
                    <td class="desc" style="font-weight:bold;">{{ gin_pass_details.cont_no }}</td>
                    <td class="unit" style="font-weight:bold;">{{ gin_pass_details.size_type }}</td>
                    <td class="qty">{{ gin_pass_details.seal_no }}</td>
                    <td class="total"  style="font-weight:bold;">{{ gin_pass_details.truck_no }}</td>
                    <td class="total">{{ gin_pass_details.vessel }} &amp; {{ gin_pass_details.voyage }}</td>
                    <td class="qty">{{ gin_pass_details.eir_no }}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="sheaderr">Transport : {{ gin_pass_details.transporter }}</td>
                    <td colspan="4" class="sign" style="border-left: 0;">Vilsons Container Freight Station</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3" class="sheaderr" style="font-weight:bold;">Scanned: {{ gin_pass_details.is_scanned }}</td>
                    <td colspan="4" style="border-left: 0; border-top: 0;"></td>
                  </tr>
                  <tr>
                    <td colspan="7" class="sheaderr" style="height: 30px;">Importer: {{ gin_pass_details.importer }}</td>
                  </tr>
                  <tr>
                    <td colspan="7" class="sign">Authorised Signature</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="sheaderr">E &amp; O.E (Errors and Omissions Excepted)</td>
                    <td colspan="4" class="sign" style="border-left: 0; border-top: 0;">{{ gin_pass_details.created_by }}</td>
                  </tr>
                </tfoot>
              </table>
            <footer>
              This is generated on a computer and is valid without the signature and seal.<br/>
              for enquiry please mail us on managercfs@vilship.com. Thanks for your business!
            </footer>
            </main>
            </div>
        </body>
    </v-layout>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ginpass',
    data() {
        return {
            gin_pass_details: [],
            pass_no: null,
            in_date: null,
            port_out_time: null,
            igm_no: null,
            igm_date: null,
            bl_no: null,
            bl_date: null,
            vessel: null,
            voyage: null,
            line: null,
            transporter: null,
            cargo: null,
            importer: null,
            is_scanned: null,
            eir_no: null,
            job_order_no: null,
        }
    },
    mounted:function() {
        this.getData()
    },
    methods: {
      getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/passes/gate_ins?gin_id=" + this.$route.params.gin_id
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.gin_pass_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        }
    }
}
</script>